import { Link } from "react-router";

export function Footer() {
	return (
		<footer className="mt-24 border-t border-border bg-surface/40">
			<div className="mx-auto max-w-7xl px-4 md:px-6 py-10 flex flex-col md:flex-row gap-8 md:items-start md:justify-between">
				<div className="max-w-sm">
					<div className="flex items-center gap-2 font-display font-bold text-lg mb-3">
						<span
							className="inline-block h-7 w-7 rounded-lg bg-gradient-to-br from-primary via-accent to-purple"
							aria-hidden="true"
						/>
						<span>
							<span className="text-ink">Genie</span>
							<span className="text-primary">Worlds</span>
						</span>
					</div>
					<p className="text-sm text-ink-muted leading-relaxed">
						Polished games built by creators on GenieForge. Free to
						play, no sign up. Want to make one?{" "}
						<a
							href="https://genieforge.io"
							className="text-primary hover:underline"
						>
							Start building →
						</a>
					</p>
				</div>

				<div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
					<div>
						<h4 className="font-semibold text-ink mb-3">Play</h4>
						<ul className="space-y-2 text-ink-muted">
							<li>
								<Link to="/" className="hover:text-ink">
									Home
								</Link>
							</li>
							<li>
								<Link to="/browse" className="hover:text-ink">
									Browse All
								</Link>
							</li>
							<li>
								<Link to="/search" className="hover:text-ink">
									Search
								</Link>
							</li>
						</ul>
					</div>
					<div>
						<h4 className="font-semibold text-ink mb-3">Create</h4>
						<ul className="space-y-2 text-ink-muted">
							<li>
								<a
									href="https://genieforge.io"
									className="hover:text-ink"
								>
									GenieForge
								</a>
							</li>
							<li>
								<a
									href="https://genieforge.io"
									className="hover:text-ink"
								>
									Templates
								</a>
							</li>
						</ul>
					</div>
					<div>
						<h4 className="font-semibold text-ink mb-3">About</h4>
						<ul className="space-y-2 text-ink-muted">
							<li>
								<a href="/" className="hover:text-ink">
									What is this
								</a>
							</li>
							<li>
								<a href="/" className="hover:text-ink">
									Privacy
								</a>
							</li>
							<li>
								<a href="/" className="hover:text-ink">
									Terms
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="border-t border-border">
				<div className="mx-auto max-w-7xl px-4 md:px-6 py-4 text-xs text-ink-faint">
					© {new Date().getFullYear()} GenieForge. Built with Phaser
					3 and a lot of juice.
				</div>
			</div>
		</footer>
	);
}
